import * as Schema from "effect/Schema";

const Text = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(4000));
const Commit = Schema.String.check(Schema.isPattern(/^[0-9a-f]{40,64}$/u));
const Count = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0));

export const RepositoryReadInput = Schema.Struct({
  action: Schema.Literals(["repositories", "list", "read", "search", "review"]),
  connectionId: Schema.optionalKey(Text),
  repositoryId: Schema.optionalKey(Text),
  branch: Schema.optionalKey(Text),
  commit: Schema.optionalKey(Commit),
  baseBranch: Schema.optionalKey(Text),
  path: Schema.optionalKey(Text),
  query: Schema.optionalKey(Text),
  recursive: Schema.optionalKey(Schema.Boolean),
  startLine: Schema.optionalKey(
    Schema.Int.check(Schema.isBetween({ minimum: 1, maximum: 1_000_000 })),
  ),
  offset: Schema.optionalKey(
    Schema.Int.check(Schema.isBetween({ minimum: 0, maximum: 1_000_000 })),
  ),
  limit: Schema.optionalKey(Schema.Int.check(Schema.isBetween({ minimum: 1, maximum: 1000 }))),
  maxChars: Schema.optionalKey(
    Schema.Int.check(Schema.isBetween({ minimum: 4000, maximum: 64000 })),
  ),
});
export type RepositoryReadInput = typeof RepositoryReadInput.Type;

const Source = {
  url: Schema.String,
  branch: Schema.String,
  commit: Commit,
};

export const RepositoryReviewRegion = Schema.Struct({
  path: Schema.String,
  commit: Commit,
  side: Schema.Literals(["base", "head"]),
  startLine: Count,
  endLine: Count,
  complete: Schema.Boolean,
  nextLine: Schema.NullOr(Count),
});
export type RepositoryReviewRegion = typeof RepositoryReviewRegion.Type;

export const RepositoryReviewContext = Schema.Struct({
  ...Source,
  comparison: Schema.optionalKey(
    Schema.Struct({ branch: Schema.String, commit: Commit, mergeBase: Commit }),
  ),
  context: Schema.String,
  regions: Schema.Array(RepositoryReviewRegion),
  files: Schema.Array(Schema.String),
  nextOffset: Schema.NullOr(Count),
  omissions: Schema.Struct({
    sources: Schema.Array(Schema.String),
    instructions: Schema.Array(Schema.String),
    related: Count,
  }),
  coverage: Schema.Struct({
    files: Count,
    supplied: Count,
    omitted: Count,
    indexed: Count,
    unsupported: Count,
    incomplete: Schema.Boolean,
  }),
  cache: Schema.Struct({ hits: Count, misses: Count }),
  budget: Schema.Struct({ maxChars: Count, usedChars: Count }),
});
export type RepositoryReviewContext = typeof RepositoryReviewContext.Type;

export const RepositoryReadResult = Schema.Union([
  Schema.Struct({
    ...Source,
    files: Schema.Array(Schema.String),
    truncated: Schema.Boolean,
    nextOffset: Count,
  }),
  Schema.Struct({
    ...Source,
    path: Schema.String,
    startLine: Count,
    content: Schema.String,
    endLine: Schema.NullOr(Count),
    truncated: Schema.Boolean,
  }),
  Schema.Struct({
    ...Source,
    matches: Schema.Array(Schema.Struct({ path: Schema.String, line: Count, text: Schema.String })),
    truncated: Schema.Boolean,
    nextOffset: Count,
  }),
  RepositoryReviewContext,
]);
export type RepositoryReadResult = typeof RepositoryReadResult.Type;
